export default {"src":"/login-app/[GIT_HASH]/_next/static/media/graph.20182b3a.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};